import React, { MouseEventHandler, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { TextField } from '@material-ui/core';

import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import { RefusalDialogWrapper } from 'containers/CourtManagerLegalProceedings/JudgementAdd/styled-components';
import { formatDecision } from 'containers/CourtManagerLegalProceedings/AppealAdd/utils';
import { PROCEDURE_STATUSES } from 'containers/data-structure';
import { toast } from 'react-toastify';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { Listings } from 'containers/AppContainer/typings';

import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import { get } from 'lodash';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

export interface RefusalDialogAppealProps {
  intl: IntlShape;
  handleCancel: MouseEventHandler;
  isRefuseDialogOpen: boolean;
  requestMakeJudgementAddDecision: Function;
  lawyer: string;
  claimId: number;
  claimNumber: string;
  listing: Listings;
  judgementId: number;
  policyInfo: any;
  judgementAdd: any;
  claim: any;
  setIsButtonRedirect: Function;
  setOpenFeeNoteDialog: Function;
}

export const RefusalDialogAppeal: React.FC<RefusalDialogAppealProps> = (
  props,
): JSX.Element => {
  const [refusalReason, setRefusalReason] = useState<string>('');

  const handleChangeRefusalReason = (
    event: React.ChangeEvent<{
      value: string;
    }>,
  ) => {
    setRefusalReason(event.target.value);
  };

  const judgementAddDocumentId = get(
    get(props.judgementAdd, 'judgementAddDocuments', []).find(
      (el: any) => !el.status,
    ),
    'id',
  );

  const handleRefusal = () => {
    props.setIsButtonRedirect(true);

    const decision = formatDecision(
      PROCEDURE_STATUSES.TO_EDIT,
      props.claimId,
      props.judgementAdd,
      refusalReason,
      get(props.claim, 'assignment.assignedLawyer'),
      false,
    );
    props.requestMakeJudgementAddDecision(
      {
        ...decision,
        claimNumber: props.claimNumber,
        judgementAddDocumentId,
        procedureType: PROCEDURE_TYPES.APPEAL,
        judiciaryProcessId: get(props.judgementAdd, 'judiciaryProcessId'),
        toUpdate: false,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      handleSuccessCallback,
    );
  };
  /* istanbul ignore next */
  const handleSuccessCallback = () => {
    toast.success(
      translate(messages.courtManagerRefusalDialogSuccessMessage, props, {
        lawyer: props.lawyer,
      }),
    );
    const event = {} as React.MouseEvent<HTMLElement>;

    if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)();
    } else if (featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      return props.setOpenFeeNoteDialog(true);
    }
    props.handleCancel(event);
  };

  return (
    <RefusalDialogWrapper
      className="refusal-content"
      handleValidate={handleRefusal}
      handleClose={props.handleCancel}
      title={translate(messages.courtManagerRefuseDialogTitle, props)}
      cancelTitle={translate(
        messages.courtManagerRefusalDialogReasonCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerRefusalDialogReasonValidate,
        props,
      )}
      open={props.isRefuseDialogOpen}
      validateButtonDisabled={!refusalReason}
    >
      <div className="reason-wrapper">
        {featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
          get(props.judgementAdd, 'status') === PROCEDURE_STATUSES.TO_EDIT && (
            <span>
              {translate(messages.courtManagerRejectionTitleDialog, props)}
            </span>
          )}
        <TextField
          id="judgement-add-rejection-reason"
          label={translate(
            messages.courtManagerRefusalDialogReasonLabel,
            props,
          )}
          onChange={handleChangeRefusalReason}
          value={refusalReason}
          fullWidth
        />
      </div>
    </RefusalDialogWrapper>
  );
};

export default injectIntl(RefusalDialogAppeal);
